<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">短时记忆功能</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			在视频流人脸识别过程中，设置陌生人短时记忆功能，该函数必须在SKFaceVideoTrackInit()初始化成功后才能调用。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool __stdcall SKFaceSetStrangerMemoryFlag(bool bStrangerMemoryFlag);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">bStrangerMemoryFlag: true打开“陌生人短时记忆”，false:关闭“陌生人短时记忆”。</p>
        
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">返回：true开启陌生人短时记忆功能，返回false不开启陌生人短时记忆功能。（开启后：识别到“陌生人”，Name会返回“[StrangerID]”，例如“[00000001]”、“[00000002]”，表示“陌生人1”、“陌生人2”。不开启：识别到“陌生人”，Name会返回“陌生人”。）
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">bool bRet = SKFaceSetStrangerMemoryFlag(false);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','事件接口','短时记忆功能'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/event/shortTimeMemory.vue